import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import { JandiSymbol } from "@/components/assets/logos/svgs";
import RegisterWorkerForm from "@/pages/auth/register/registerWorkerForm"
import RegisterContractorForm from "@/pages/auth/register/registerContractorForm"
import { useTranslation } from "react-i18next";
const Register = ({handlePopupType,RegisterType, onSuccess}) => {
    const { t } = useTranslation();


    return (

        <div className="login-form default-form">
            <div className="form-inner">
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: 20,
                    }}
                >
                   <img
            src="/images/phone_symbol.svg"
            alt="Phone Symbol"
            style={{
              width: '60px',
              height: '60px',
              display: 'block'
            }}
          />
                </div>
                <h3 className="text-center" style={{ color: "white", fontWeight: 600 }}>Jandi - {t('panel')}</h3>

                {/* <Tabs>
                    <div className="form-group register-dual">
                        <TabList className="btn-box row">
                            <Tab className="col-lg-6 col-md-12">
                                <button
                                    style={{ borderRadius: 0 }}
                                    className="theme-btn btn-style-four"
                                >
                                    <i className="la la-user"></i> Contratar
                                </button>
                            </Tab>

                            <Tab className="col-lg-6 col-md-12">
                                <button
                                    style={{ borderRadius: 0 }}
                                    className="theme-btn btn-style-four"
                                >
                                    <i className="la la-briefcase"></i> Ofrecer Servicios
                                </button>
                            </Tab>
                        </TabList>
                    </div>

                    <TabPanel>
                        <RegisterContractorForm handlePopupType={handlePopupType} />
                    </TabPanel>

                    <TabPanel>
                        <RegisterWorkerForm handlePopupType={handlePopupType} />
                    </TabPanel>
                </Tabs> */}


                 {RegisterType === "worker" && (
          <RegisterWorkerForm handlePopupType={handlePopupType} onSuccess={onSuccess} />
        )}

        {RegisterType === "user" && (
          <RegisterContractorForm handlePopupType={handlePopupType} onSuccess={onSuccess} />
        )}


                <div className="bottom-box pt-0">
                    <div className="text" style={{ color: "white" }}>
                        {t('alreadyHaveAccount')}{" "}
                        <button
                            onClick={()=>handlePopupType('login')}
                            className="call-modal login"
                            style={{ color: "white" }}
                        >
                            {t('login')}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Register;